import * as React from "react";
import {ITranslatedComponent, ITypefamilyMap} from "../../../redux/reducers/generalReducer";
import {translate} from "react-i18next";
import {connect} from "react-redux";

import SelectField from "../../../components/SelectField";
import {
    ModelyearDto,
    CnrDto,
    ImporterDto,
    TypefamilyDto,
    ModeltypeBasicDto,
    SpecDto,
    SpecConfigurationDto,
    ResourceListOfSpecDto,
    ResourceListOfImporterDto,
    ResourceListOfSpecConfigurationDto,
    MenuDto, ResourceListOfModelyearDto
} from "../../../services/Client";
import _ from "lodash";
import {scIsEqual, IGroupMap, toSpecConfigurationDto, getSpecsForSelected, showSpecs, createGroupMap, ISetSpecs} from "./SpecConfigurationHelpers";
import SpecConfigurationBlock from "./SpecConfigurationBlock";
import {Table} from "semantic-ui-react";
import SpecConfigurationSpecSelection from "./SpecConfigurationSpecSelection";
import {renderErrorToast} from "../../../utils/FeedbackMessageUtils";
import {DerivateUtils} from "../../../components/Table/components/derivate/DerivateUtils";
import GeneralActions from "../../../redux/actions/GeneralActions";
import AdminViewActions from "../../../redux/actions/AdminViewActions";
import {compose, Dispatch} from "redux";
import HATEOASClient from "../../../services/HATEOASClient";
import {
    selectClient,
    selectCnrList,
    selectModelyears,
    selectTypefamilyMap,
    selectAdminArealinks,
    selectDerivates,
    selectImporterList,
    selectSpecConfigs,
    selectSpecs, selectLanguage
} from "../../../redux/selectors";
import {IReduxState} from "src/redux/IReduxState";

interface IMapStateToProps {
    adminAreaLinks?: MenuDto;
    client: HATEOASClient;
    specConfigs?: ResourceListOfSpecConfigurationDto;
    specs?: SpecDto[];
    cnrList?: CnrDto[];
    modelYears?: ResourceListOfModelyearDto;
    typefamilyMap?: ITypefamilyMap;
    derivates?: ModeltypeBasicDto[];
    importerList?: ImporterDto[];
    userLanguage: string;
}

interface IMapDispatchToProps {
    addLoadingMessage: (msg: string) => void;
    removeLoadingMessage: (msg: string) => void;
    receiveImporterList: (importers: ImporterDto[]) => void;
    receiveSpecs: (specs?: SpecDto[]) => void;
    receivedSpecConfigurations: (specConfigs?: ResourceListOfSpecConfigurationDto) => void;
    getSpecConfigurations: (links?: MenuDto) => void;
    unloadDerivates: () => void;
    getDerivates: (modelyear: ModelyearDto) => void;
}

interface IOwnProps {
    displayItems?: number;
}

interface ISpecConfigurationProps extends IOwnProps, IMapStateToProps, IMapDispatchToProps, ITranslatedComponent {
}

export interface ISpecConfiguration {
    modelyear?: ModelyearDto;
    cnr?: CnrDto;
    importer?: ImporterDto;
    typeFamily?: TypefamilyDto;
    modeltypeBasic?: ModeltypeBasicDto;
}

interface ISpecConfigurationState {
    selectedModelYear?: ModelyearDto;
    selectedCnr?: CnrDto;
    selectedImp?: ImporterDto;
    selectedTf?: TypefamilyDto;
    selectedMTB?: ModeltypeBasicDto;

    groupMap?: IGroupMap;

    // the applied specification for the selected level/item
    appliedSpecification: ISetSpecs;

    refreshTrigger: boolean;
}

class SpecConfiguration extends React.Component<ISpecConfigurationProps, ISpecConfigurationState> {
    state: ISpecConfigurationState = {
        selectedModelYear: undefined,
        groupMap: undefined,
        refreshTrigger: false,
        appliedSpecification: {}
    };

    componentDidMount() {
        this.requestData();
    }

    componentWillReceiveProps(nextProps: ISpecConfigurationProps) {
        if (!_.isEqual(nextProps.specConfigs, this.props.specConfigs)) {
            this.setState({refreshTrigger: !this.state.refreshTrigger});
        }
    }

    findSpecConfig(specConfig: ISpecConfiguration): SpecConfigurationDto | undefined {
        if (this.props.specConfigs && this.props.specConfigs.elements && specConfig.modelyear) {
            let temp = toSpecConfigurationDto(specConfig);
            return this.props.specConfigs.elements.find((v: SpecConfigurationDto) => scIsEqual(v, temp));
        }
        return undefined;
    }

    requestData = (): void => {
        const {client, adminAreaLinks} = this.props;

        const loadingMsg = this.props.t("GET_SPEC_CONFIG_DATA");
        this.props.addLoadingMessage(loadingMsg);

        if (!adminAreaLinks ||
            !client.GET_specs(adminAreaLinks).canExecute() ||
            !client.GET_importerList(adminAreaLinks).canExecute() ||
            !client.GET_specConfigList(adminAreaLinks).canExecute()) {
            this.props.removeLoadingMessage(loadingMsg);
            renderErrorToast({
                message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            return;
        }

        const requestImporters = client.GET_importerList(adminAreaLinks);
        const requestSpecs = client.GET_specs(adminAreaLinks);
        const requestSpecConfigs = client.GET_specConfigList(adminAreaLinks);

        Promise.all([requestImporters.execute(), requestSpecs.execute(), requestSpecConfigs.execute()])
            .then((response: [ResourceListOfImporterDto, ResourceListOfSpecDto, ResourceListOfSpecConfigurationDto]) => {
                const [importerList, specs, specConfigs] = response;

                this.props.receiveImporterList(importerList.elements ? importerList.elements : []);
                this.props.receiveSpecs(specs.elements);
                this.props.receivedSpecConfigurations(specConfigs);

                this.props.removeLoadingMessage(loadingMsg);
            })
            .catch((reason: any) => {
                window.scrollTo(0, 0);
                renderErrorToast({
                    message: "ERRORS:GET_SPEC_CONFIG_DATA",
                    details: reason,
                    timestamp: Date.now()
                });
            });
    }

    renderCardDescription(specConfig: ISpecConfiguration, updateMethod: () => void): JSX.Element {
        let valueList: string[] = [];
        let sc: SpecConfigurationDto | undefined = undefined;
        if (specConfig.modelyear) {
            sc = this.findSpecConfig(specConfig);
            valueList = sc ? sc.specs : [];
        }
        let ds: SpecDto[] = this.props.specs ? this.props.specs : [];
        let value: SpecDto[] = [];
        _.forEach(valueList, (val) => {
            let e = _.find(ds, (v: SpecDto) => v.specCode === val);
            if (e) {
                value.push(e);
            }
        });

        let methodTest = (param: SpecConfigurationDto) =>
            sc ?
                this.props.client.PATCH_specConfig(sc).canExecute() :
                this.props.specConfigs ?
                    this.props.client.POST_specConfig(this.props.specConfigs).canExecute() :
                    false;

        let methodExec = (param: SpecConfigurationDto) =>
            sc ?
                this.props.client.PATCH_specConfig(sc).execute(param) :
                this.props.specConfigs ?
                    this.props.client.POST_specConfig(this.props.specConfigs).execute(param) :
                    Promise.reject("could not find links for saving spec configuration");

        let tryMethod = (param: SpecConfigurationDto, work: () => void): void => {
            if (methodTest(param)) {
                methodExec(param).then(
                    (res: any) => {
                        work();
                    },
                    (reason: any) => {
                        renderErrorToast(
                            {
                                message: "SAVE_SPEC_CONFIGURATION",
                                timestamp: Date.now(),
                                details: reason
                            }
                        );
                        this.forceUpdate();
                    }
                );
            }
        };

        return (
            <SpecConfigurationSpecSelection
                dataSource={ds}
                disabled={!(sc ? this.props.client.PATCH_specConfig(sc).canExecute() :
                    this.props.specConfigs && this.props.client.POST_specConfig(this.props.specConfigs).canExecute())}
                value={value}
                onChange={(specs: string[]) => {
                    if (sc) {
                        let newSC = Object.assign({}, sc);
                        newSC.specs = specs;
                        tryMethod(newSC, () => this.props.getSpecConfigurations(this.props.adminAreaLinks));
                    } else {
                        if (this.props.specConfigs && this.props.specConfigs.elements) {
                            let newSC = toSpecConfigurationDto(specConfig);
                            newSC.specs = specs;
                            tryMethod(newSC, () => this.props.getSpecConfigurations(this.props.adminAreaLinks));
                        }
                    }
                }}
            />
        );
    }

    handleChange(level: number, selectedValue: any) {
        let {state} = this;
        switch (level) {
            case 0: // modelyear
                this.props.unloadDerivates();
                this.props.getDerivates(selectedValue);
                state.selectedModelYear = selectedValue;
                state.selectedTf = undefined;
                state.selectedMTB = undefined;
                break;
            case 1: // cnr
                state.selectedCnr = selectedValue;
                break;
            case 2: // importer
                state.selectedImp = selectedValue;
                break;
            case 3: // typefamily
                state.selectedTf = selectedValue;
                state.selectedMTB = undefined;
                break;
            case 4: // mtb
                state.selectedMTB = selectedValue;
                break;
            default: // undefined
                break;
        }
        let specConfig: ISpecConfiguration =
        {
            modelyear: state.selectedModelYear,
            cnr: state.selectedCnr,
            importer: state.selectedImp,
            typeFamily: state.selectedTf,
            modeltypeBasic: state.selectedMTB
        };
        state.appliedSpecification = getSpecsForSelected(
            specConfig,
            this.props.specs,
            this.props.specConfigs && this.props.specConfigs.elements ? this.props.specConfigs.elements : [],
            this.state.groupMap
        );
        state.refreshTrigger = !state.refreshTrigger;
        this.setState(state);
    }

    render() {
        let ds = this.props.modelYears && this.props.modelYears.elements ? this.props.modelYears.elements : [];

        if (!this.state.groupMap && this.props.specs) {
            this.setState({groupMap: createGroupMap(this.props.specs)});
        }
        let cnrList: CnrDto[] = this.props.cnrList ? this.props.cnrList : [];
        let impList: ImporterDto[] = this.props.importerList ? this.props.importerList : [];
        let tfList: TypefamilyDto[] = [];
        let showTf = false;
        let mtbList: ModeltypeBasicDto[] = [];

        if (this.props.derivates && this.state.selectedTf) {
            let mtb = this.props.derivates;
            let tf = this.state.selectedTf;
            _.forEach(mtb, (val) => {
                if (tf.objectId === val.typefamily.objectId) {
                    mtbList.push(val);
                }
            });
        }
        mtbList.sort(DerivateUtils.compareByBtyp);

        if (this.state.selectedModelYear && this.props.typefamilyMap) {
            let rList = this.props.typefamilyMap[this.state.selectedModelYear.mj1];
            if (rList.elements) {
                tfList = rList.elements;
                showTf = true;
            }
        }

        return (
            <div>
                {this.props &&
                    this.props.modelYears &&
                    this.props.modelYears.elements &&
                    this.state.groupMap &&
                    <div>
                        <Table>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell>
                                        <div className="SpecFirstHeader">{this.props.t("MODELYEAR_FOR_SPECS")}</div>
                                        <SelectField
                                            dataSource={ds}
                                            rendererKey={(val: ModelyearDto) => val.mj1 + " (" + val.mj4 + ")"}
                                            value={this.state.selectedModelYear}
                                            onChange={(val: ModelyearDto) => this.handleChange(0, val)}
                                        />
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                        <SpecConfigurationBlock
                            refreshTrigger={this.state.refreshTrigger}
                            displayItems={this.props.displayItems}
                            assignTo="cnr"
                            baseSpec={{modelyear: this.state.selectedModelYear}}
                            dataList={cnrList}
                            onSelect={(selected: CnrDto) => this.handleChange(1, selected)}
                            createCardData={(item: CnrDto, specConfig: ISpecConfiguration) => ({
                                header: item.name,
                                meta: "",
                                description: this.renderCardDescription(specConfig, () => this.handleChange(1, this.state.selectedCnr)),
                                cnr: item.cnr
                            })}
                            visible={this.props.cnrList !== undefined &&
                                this.state.selectedModelYear !== undefined}
                            t={this.props.t}
                        >
                            <div className="SpecHeader">{this.props.t("CNR_FOR_SPECS")}</div>
                        </SpecConfigurationBlock>

                        <SpecConfigurationBlock
                            refreshTrigger={this.state.refreshTrigger}
                            displayItems={this.props.displayItems}
                            assignTo="importer"
                            baseSpec={{
                                modelyear: this.state.selectedModelYear,
                                cnr: this.state.selectedCnr
                            }}
                            dataList={impList}
                            onSelect={(selected: ImporterDto) => this.handleChange(2, selected)}
                            createCardData={(item: any, specConfig: ISpecConfiguration) => ({
                                header: item.name,
                                meta: "",
                                description: this.renderCardDescription(specConfig, () => this.handleChange(2, this.state.selectedImp)),
                                cnr:item.cnr
                            })}
                            visible={this.props.importerList !== undefined &&
                                this.state.selectedModelYear !== undefined &&
                                this.state.selectedCnr !== undefined}
                            t={this.props.t}
                        >
                            <div className="SpecHeader">{this.props.t("IMPORTER_FOR_SPECS")}</div>
                        </SpecConfigurationBlock>

                        <SpecConfigurationBlock
                            refreshTrigger={this.state.refreshTrigger}
                            displayItems={this.props.displayItems}
                            assignTo="typeFamily"
                            baseSpec={{
                                modelyear: this.state.selectedModelYear,
                                cnr: this.state.selectedCnr,
                                importer: this.state.selectedImp
                            }}
                            dataList={tfList}
                            onSelect={(selected: TypefamilyDto) => this.handleChange(3, selected)}
                            createCardData={(item: any, specConfig: ISpecConfiguration) => ({
                                header: item.name,
                                meta: "",
                                description: this.renderCardDescription(specConfig, () => this.handleChange(3, this.state.selectedTf)),
                                cnr: item.cnr
                            })}
                            t={this.props.t}
                            visible={showTf &&
                                this.state.selectedModelYear !== undefined &&
                                this.state.selectedCnr !== undefined &&
                                this.state.selectedImp !== undefined}
                        >
                            <div className="SpecHeader">{this.props.t("TYPEFAMILY_FOR_SPECS")}</div>
                        </SpecConfigurationBlock>

                        <SpecConfigurationBlock
                            refreshTrigger={this.state.refreshTrigger}
                            displayItems={this.props.displayItems}
                            assignTo="modeltypeBasic"
                            baseSpec={{
                                modelyear: this.state.selectedModelYear,
                                cnr: this.state.selectedCnr,
                                importer: this.state.selectedImp,
                                typeFamily: this.state.selectedTf
                            }}
                            dataList={mtbList}
                            onSelect={(selected: ModeltypeBasicDto) => this.handleChange(4, selected)}
                            createCardData={(item: any, specConfig: ISpecConfiguration) => ({
                                header: DerivateUtils.renderDerivateName(item, this.props.userLanguage) || "",
                                meta: item.btyp ? item.btyp : "",
                                description: this.renderCardDescription(specConfig, () => this.handleChange(4, this.state.selectedMTB)),
                                cnr: item.cnr
                            })}
                            t={this.props.t}
                            visible={mtbList.length > 0 &&
                                this.state.selectedModelYear !== undefined &&
                                this.state.selectedCnr !== undefined &&
                                this.state.selectedImp !== undefined &&
                                this.state.selectedTf !== undefined}
                        >
                            <div className="SpecHeader">{this.props.t("DERIVATE_FOR_SPECS")}</div>
                        </SpecConfigurationBlock>
                        {showSpecs(
                            {
                                modelyear: this.state.selectedModelYear,
                                cnr: this.state.selectedCnr,
                                importer: this.state.selectedImp,
                                typeFamily: this.state.selectedTf,
                                modeltypeBasic: this.state.selectedMTB
                            },
                            this.state.appliedSpecification,
                            this.props.t("APPLIED_SPECS"),
                            this.props.userLanguage)}
                        <div style={{height: 250}}>&nbsp;</div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    adminAreaLinks: selectAdminArealinks(state),
    client: selectClient(state),
    specConfigs: selectSpecConfigs(state),
    specs: selectSpecs(state),
    cnrList: selectCnrList(state),
    modelYears: selectModelyears(state),
    typefamilyMap: selectTypefamilyMap(state),
    derivates: selectDerivates(state),
    importerList: selectImporterList(state),
    userLanguage: selectLanguage(state)
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: ISpecConfigurationProps): IMapDispatchToProps => ({
    addLoadingMessage: (msg: string) => dispatch(GeneralActions.AddLoadingMessage(msg)),
    removeLoadingMessage: (msg: string) => dispatch(GeneralActions.RemoveLoadingMessage(msg)),
    receiveImporterList: (importers: ImporterDto[]) => dispatch(AdminViewActions.ReceiveImporterList(importers)),
    receiveSpecs: (specs?: SpecDto[]) => dispatch(AdminViewActions.ReceiveSpecs(specs)),
    receivedSpecConfigurations: (specConfigs?: ResourceListOfSpecConfigurationDto) => dispatch(AdminViewActions.ReceivedSpecConfigurations(specConfigs)),
    getSpecConfigurations: (links?: MenuDto) => dispatch(AdminViewActions.GetSpecConfigurations(ownProps.t, links, true)),
    unloadDerivates: () => dispatch(AdminViewActions.UnloadDerivates()),
    getDerivates: (modelyear: ModelyearDto) => dispatch(GeneralActions.GetDerivates(ownProps.t, modelyear, false)),
});

export default compose<React.ComponentType<IOwnProps>>(
    translate("SPEC_CONFIG"),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(SpecConfiguration);



// WEBPACK FOOTER //
// ./src/views/AdminView/SpecConfigTab/SpecConfiguration.tsx